export const scrollToAnchor = (route: any) => {
  if (route.query.anchor) {
    setTimeout(() => {
      const images = document.querySelectorAll("img");
      const imagePromises: Promise<void>[] = [];

      images.forEach((image) => {
        const imgPromise = new Promise<void>((resolve) => {
          const img = new Image();
          img.src = image.src;
          img.onload = () => resolve();
          img.onerror = () => resolve(); // 处理加载失败的情况
        });
        imagePromises.push(imgPromise);
      });

      Promise.all(imagePromises).then(() => {
        const element = document.getElementById(route.query.anchor);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      });
    }, 0);
  }
};


export function formatTime(date: any, fmt: any) {
	//时间格式处理
	let ret:any = ''
	date = new Date(date)
	const opt:any = {
		'Y+': date.getFullYear().toString(), // 年
		'm+': (date.getMonth() + 1).toString(), // 月
		'd+': date.getDate().toString(), // 日
		'H+': date.getHours().toString(), // 时
		'M+': date.getMinutes().toString(), // 分
		'S+': date.getSeconds().toString() // 秒
	}
	for (let k in opt) {
		ret = new RegExp('(' + k + ')').exec(fmt)
		if (ret) {
			fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'))
		}
	}
	return fmt
}